<template>
  <v-footer class="footer">
    <div class="footer-container">
      <!-- 상단 영역 -->
      <div class="footer-top">
        <!-- 브랜드 영역 -->
        <div class="footer-brand">
          <div class="brand-logo">
            <div class="logo-icon">
              <v-icon color="white" size="24">mdi-code-braces</v-icon>
            </div>
            <span class="logo-text">Yuniq Coding</span>
          </div>
          <p class="brand-description">
            한끗 다른 수업으로<br>
            코딩의 즐거움을 전합니다
          </p>
        </div>

        <!-- 링크 영역 -->
        <div class="footer-nav">
          <h4 class="nav-title">바로가기</h4>
          <nav class="nav-links">
            <router-link
              v-for="item in footerLinks"
              :key="item.path"
              :to="item.path"
              class="nav-link"
            >
              {{ item.label }}
            </router-link>
          </nav>
        </div>

        <!-- 연락처 영역 -->
        <div class="footer-contact">
          <h4 class="nav-title">연락처</h4>
          <div class="contact-info">
            <a href="mailto:totquf52@naver.com" class="contact-item">
              <v-icon size="16">mdi-email-outline</v-icon>
              <span>totquf52@naver.com</span>
            </a>
          </div>
        </div>
      </div>

      <!-- 구분선 -->
      <div class="footer-divider"></div>

      <!-- 하단 영역 -->
      <div class="footer-bottom">
        <p class="copyright">
          &copy; 2025 Yuniq Coding. All rights reserved.
        </p>

        <!-- 소셜 링크 -->
        <div class="social-links">
          <a
            v-for="social in socialLinks"
            :key="social.name"
            :href="social.url"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
            :title="social.name"
          >
            <v-icon size="18">{{ social.icon }}</v-icon>
          </a>
        </div>
      </div>
    </div>
  </v-footer>
</template>

<script setup>
const footerLinks = [
  { path: '/', label: '홈' },
  { path: '/about', label: '강사 소개' },
  { path: '/schedule', label: '스케줄' },
  { path: '/apply', label: '강의 신청' }
]

const socialLinks = [
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/yuniq.coding/',
    icon: 'mdi-instagram'
  },
  {
    name: 'GitHub',
    url: 'https://github.com/YuniqCoding',
    icon: 'mdi-github'
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/%EC%9C%A0%EB%9D%BC-%EC%B5%9C-120a09196/',
    icon: 'mdi-linkedin'
  },
  {
    name: 'Blog',
    url: 'https://brunch.co.kr/@dc6d817eaf3b480/112',
    icon: 'mdi-post-outline'
  }
]
</script>

<style scoped>
.footer {
  background: var(--black-primary) !important;
  border-top: 1px solid rgba(164, 120, 100, 0.2);
  padding: 48px 24px 24px !important;
  min-height: auto !important;
  height: auto !important;
  width: 100% !important;
  display: block !important;
  flex-direction: column !important;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 상단 영역 */
.footer-top {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 48px;
  margin-bottom: 32px;
}

/* 브랜드 */
.footer-brand {
  max-width: 300px;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: var(--mocha-mousse);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  font-family: var(--font-display);
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  color: var(--white-primary);
}

.brand-description {
  font-size: var(--text-sm);
  color: var(--gray-dark);
  line-height: 1.6;
}

/* 네비게이션 */
.nav-title {
  font-size: var(--text-sm);
  font-weight: var(--font-semibold);
  color: var(--white-primary);
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nav-link {
  font-size: var(--text-sm);
  color: var(--gray-dark);
  text-decoration: none;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: var(--mocha-mousse);
}

/* 연락처 */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--text-sm);
  color: var(--gray-dark);
  text-decoration: none;
  transition: color 0.2s ease;
}

.contact-item:hover {
  color: var(--mocha-mousse);
}

/* 구분선 */
.footer-divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(164, 120, 100, 0.3),
    transparent
  );
  margin-bottom: 24px;
}

/* 하단 영역 */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright {
  font-size: var(--text-xs);
  color: var(--gray-dark);
}

/* 소셜 링크 */
.social-links {
  display: flex;
  gap: 8px;
}

.social-link {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  color: var(--gray-dark);
  transition: all 0.2s ease;
}

.social-link:hover {
  background: var(--mocha-mousse);
  color: white;
  transform: translateY(-2px);
}

/* 반응형 */
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer-top {
    grid-template-columns: 1fr;
    gap: 32px;
    text-align: center;
  }

  .footer-brand {
    max-width: 100%;
  }

  .brand-logo {
    justify-content: center;
  }

  .nav-links {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  .contact-info {
    align-items: center;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .social-links {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 0 16px;
  }

  .nav-links {
    gap: 12px;
  }

  .social-link {
    width: 32px;
    height: 32px;
  }
}
</style>
